import { twMerge } from "tailwind-merge";
import { SupplierGetResponseType } from "@sellar-io/api-v2/types";
import { ReactElement, useState } from "react";
import { Icon } from "../../../../../components";
import { Card, DataButton, H5 } from "@sellar-io/components";
import { SellarWhiteLogoPurpleLogo } from "../../../../../components/sellarLogos/SellarWhiteLogoPurpleBackground";
import { useBuyerRelationshipList } from "../../../../../hooks/api/v2/buyerRelationship/useBuyerRelationshipList";
import { useSellarCurrentBusiness } from "../../../../../hooks/useSellarCurrentBusiness.shared";
import { StorefrontMessageDialog } from "../StorefrontDialogs/StorefrontMessagesDialog/StorefrontMessagesDialog";

export const StorefrontContactSupplierBanner = ({
  supplier,
}: {
  supplier: SupplierGetResponseType;
}): ReactElement | null => {
  const { business } = useSellarCurrentBusiness();
  const [messageDialogActive, setMessageDialogActive] = useState(false);

  const buyerRelationshipListQuery = useBuyerRelationshipList(
    {
      query: [
        {
          type: "supplierId",
          modifier: "EQUALS",
          value: supplier.id,
        },
      ],
      limit: 1,
    },
    {
      enabled: !!business?.Retailer && !!supplier.id,
    },
  );

  const buyerRelationship = buyerRelationshipListQuery.data?.pages[0]?.[0];

  return (
    <>
      <Card
        className={twMerge("bg-white", "border border-zinc-300 bg-zinc-50 p-4")}
      >
        <div className="flex flex-row">
          <div className={"mr-4"}>
            <SellarWhiteLogoPurpleLogo />
          </div>
          <div className="flex flex-col gap-2">
            <div className="flex flex-col">
              <H5>Didn't find what you were looking for?</H5>
              <p>
                Send {supplier.Business.name} a message to let them know so they
                can help you out.
              </p>
            </div>
            {buyerRelationship?.id && (
              <DataButton onClick={() => setMessageDialogActive(true)}>
                <Icon icon={"MESSAGE_OUTLINE"} />
                Contact Supplier
              </DataButton>
            )}
          </div>
        </div>
      </Card>
      {!!buyerRelationship && (
        <StorefrontMessageDialog
          relationshipId={buyerRelationship.RelationshipId}
          active={messageDialogActive}
          onDismiss={() => setMessageDialogActive(false)}
          supplierName={supplier.Business.name}
        />
      )}
    </>
  );
};
